import React from 'react';
import PageBanner from '@/components/Banner/PageBanner';
import { resourceHelpers } from '@/utils/helpers';
import t from '@/utils/Language/ResourceCard-translations';

const UnavailableBanner = ({ opportunity }) => {
  if (!resourceHelpers.isCurrentlyUnavailable(opportunity)) {
    return null;
  }

  return (
    <PageBanner type="alert" icon={['fas', 'circle-xmark']} iconColor="red">
      <strong>{t('This service is currently unavailable')}</strong>
    </PageBanner>
  );
};

export default UnavailableBanner;
